import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import { wrapFontFamily } from 'common/components/entities/Text/utils'
import PropTypes from 'prop-types'
import { TriggeredPopup } from 'publisher/pages/components/triggered-popup'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React from 'react'
import Meta from '../../components/core/Meta'
import { OnExitPopup } from '../components/on-exit-popup'
import { OnloadPopups } from '../components/onload-popups'
import PageUi from '../ui/PageUi'
import { usePaypalUpsellOptions } from './hooks/use-paypal-upsell-options'

const UpsellPage = ({ children }) => {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  const paypalScriptConfig = usePaypalUpsellOptions()

  const content = (
    <>
      <Meta />
      {children}
      <TriggeredPopup />
      <OnExitPopup />
      <OnloadPopups />
      <div id="mercado-pago-dialog" />
    </>
  )

  return (
    <PageUi
      $textFontFamily={wrapFontFamily(globalTextFontProperties.fontFamily)}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      {paypalScriptConfig ? (
        <PayPalScriptProvider
          key={paypalScriptConfig.key}
          options={paypalScriptConfig.options}
        >
          {content}
        </PayPalScriptProvider>
      ) : (
        content
      )}
    </PageUi>
  )
}

UpsellPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default UpsellPage
